<template>
  <div class="d-flex justify-center align-center" id="get-app-data">
    <div class="flex-row text-center">
      <v-progress-circular
        :size="55"
        :width="4"
        color="primary"
        indeterminate
      ></v-progress-circular>
      <p class="mt-3 mb-0">Please wait...</p>
    </div>
  </div>
</template>
<script>
export default {
  created () {
    this.$axios.post('getAppData').then((res) => {
      this.$saveRight(res.data.right)
      this.$saveCompanyData(res.data.company)
      if (this.$route.params.nextRoute !== undefined) {
        if (this.$route.params.nextRoute.meta !== undefined && this.$route.params.nextRoute.meta.right !== undefined) {
          if (this.$checkRight(this.$route.params.nextRoute.meta.right)) {
            this.$router.push(this.$route.params.nextRoute.path)
          } else {
            this.$router.push('/401')
          }
        } else {
          this.$router.push(this.$route.params.nextRoute.path)
        }
      } else {
        this.$router.push({ name: 'Dashboard' })
      }
    }).catch((err) => {
      console.log(err)
    })
  },
  data: function () {
    return {
    }
  }
}
</script>
<style lang="scss">
#get-app-data {
  height: 100vh;
}
</style>
